/*

BUILD details https://create-react-app.dev/docs/production-build
1. list summary functions to write
  opportunities cost

2. make graph mockup
3. mobile-friendly forms
  a. view each and then single edit
4. describe new chart in formula, three main numbers
ALWAYS focus on key metrics
ALWAYS let the layout guide you

5. remember last values on refresh
6. if graph does deep, zoom 
  lowest point on the graph
7. fix placement of titles beneath graph if result off timeline
8. fix titles beneath graph so color not absorbed 
9. chart each simulation year by value 
10. infinite sign on the 'never out of debt result'
11. arrow on future out of debt date
12. priority list should reflect sorted priority

*/
import './App.css';
import React, { PureComponent } from 'react';
import { Bar, BarChart, Label, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, AreaChart, ReferenceLine } from 'recharts';
import { render } from '@testing-library/react';
function App() {
  /*
  window.mode = 'savings';
  window.mode = 'rentbuy';
  
  window.mode = 'rentbuy';
  window.mode = 'debtinvest';
  window.mode = 'compound';
  */

  return (
    <div className="App pwftool">
      {(!window.mode || window.mode === 'debtinvest') && <DebtInvest />}
      {(!window.mode || window.mode === 'rentbuy') && <RentBuy />}
      {(!window.mode || window.mode === 'networth') && <NetWorth />}
      {(!window.mode || window.mode === 'budget') && <BudgetCalc />}
      {(!window.mode || window.mode === 'savings') && <SavingsCalculator />}
      {(!window.mode || window.mode === 'debtincome') && <DebtIncomeRatio />}
      {(!window.mode || window.mode === 'compound') && <InterestCalc />}
      
    </div>
  );
}
const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100
  }
];
const DataFormater = (number, name) => {
  let out = 0;
  if(Math.abs(number) > 1000000000){
    out = (number/1000000000).toFixed(1).toString() + 'B';
  }else if(Math.abs(number) > 1000000){
    out = (number/1000000).toFixed(1).toString() + 'M';
  }else if(Math.abs(number) > 1000){
    out = (number/1000).toFixed(0).toString() + 'K';
  }else{
    out = (number - 0).toFixed(0).toString();
  }
  return '$' + out;
}
class InterestCalc extends React.Component {
  constructor(props){
      super(props);
      //
      this.state = {P:10000,A:0,r:3.75,n:1,t:5,pmt:100,cn:12};
      
  }
  calc() {
  
      var part =  (1 + (this.state.r/100)/this.state.n);
      var A = this.state.P * Math.pow(part,(this.state.n * this.state.t));
      //var part2 =  Math.pow(part,(this.state.n * this.state.t)) - 1;
     //part2 = part2 / ((this.state.r/100)/this.state.n);
     //https://medium.com/@diogobv.batista/a-story-about-a-graph-part-1-77fc29977322
      //A+=(this.part2 * this.state.pmt);
      A+= this.contribCompounded() ;
      //console.log(this.contribCompounded());
      this.setState({A:parseFloat(A.toFixed(2))});
  }
  contribCompounded() {
      if (this.state.r > 0) {
        return this.state.pmt * (((Math.pow((1 + (this.state.r/100) / this.state.cn), this.state.t * this.state.cn)) - 1) / ((this.state.r/100) / this.state.cn));
      } else {
        return ((this.state.t * this.state.cn) * this.state.pmt);
      }
  }
  render() {
      return(<div>
           


<label>Initial Deposit $</label>                
<input type="text" placeholder="$" onChange={(e) => {this.setState({P:e.target.value},this.calc);}} value={this.state.P}/>

<label>Estimated Rate of Return %</label>                
<input type="text" placeholder="%" onChange={(e) => {this.setState({r:e.target.value},this.calc);}} value={this.state.r}/>


<label> {this.state.cn == 52 && 'Weekly'}{this.state.cn == 12 && 'Monthly'}{this.state.cn == 1 && 'Annual'}{this.state.cn == 365 && 'Daily'} Contribution $</label> 

<input type="text" placeholder="monthy" onChange={(e) => {this.setState({pmt:e.target.value}, this.calc);}} value={this.state.pmt}/>
<label></label>
<button className={['toggle',this.state.cn==12 && 'on'].join(' ')} onClick={(e) => {this.setState({cn:12}, this.calc);}}>Monthly</button> <button className={['toggle',this.state.cn==1 && 'on'].join(' ')} onClick={(e) => {this.setState({cn:1}, this.calc);}}>Annually</button>            

<label>Investment Time in Years</label>              
<input type="text" placeholder="years" onChange={(e) => {this.setState({t:e.target.value}, this.calc);}} value={this.state.t}/>
<br /><br />
<label>Compound Frequency {1==2 && <span>{this.state.n == 52 && 'weekly'}{this.state.n == 12 && 'monthly'}{this.state.n == 1 && 'annually'}{this.state.n == 365 && 'daily'}</span>}</label>  

<button onClick={(e) => {this.setState({n:365}, this.calc);}} className={['toggle',this.state.n==365 && 'on'].join(' ')}>Daily</button> <button className={['toggle',this.state.n==52 && 'on'].join(' ')} onClick={(e) => {this.setState({n:52}, this.calc);}}>Weekly</button> <button className={['toggle',this.state.n==12 && 'on'].join(' ')} onClick={(e) => {this.setState({n:12}, this.calc);}}>Monthly</button> <button className={['toggle',this.state.n==1 && 'on'].join(' ')} onClick={(e) => {this.setState({n:1}, this.calc);}}>Annually</button>


<h3>Total Accrued Principal &amp; Interest</h3>
<div className="result">${this.state.A.toLocaleString()}</div>

{1==2 && <div>{this.state.n * this.state.t} cycles</div>}
{1==2 && <div>
  <svg viewBox="0 0 100 100" width="400" height="400" xmlns="http://www.w3.org/2000/svg">
      
      <rect x="0" y="0" width="10" height="100"/>
      <rect x="20" y="0" width="10" height="100"/>
      <rect x="40" y="0" width="10" height="100"/>
      <rect x="60" y="0" width="10" height="100"/>
  </svg>    
  </div>}
          </div>)
  }
}
class DebtInvestCharts extends React.Component {

  scenarios() {
    var out =  this.props.resultA.map((r,idx) => {
        let rB = this.props.resultB[idx];
        return {
          month : idx,
          debts : r.debts.reduce((acc,d) => acc - d.principal,0),
          investments : r.investments.reduce((acc,inv) => acc + inv.principal,0),
          networthA : r.debts.reduce((acc,d) => acc - d.principal,0) + r.investments.reduce((acc,inv) => acc + inv.principal,0),
          networthB : rB.debts.reduce((acc,d) => acc - d.principal,0) + rB.investments.reduce((acc,inv) => acc + inv.principal,0),
          interestA : r.debts.reduce((acc,d) => acc - d.interestPaid,0),
          interestB : rB.debts.reduce((acc,d) => acc - d.interestPaid,0),
          yieldA : r.investments.reduce((acc,inv) => acc + inv.yield,0),
          yieldB : rB.investments.reduce((acc,inv) => acc + inv.yield,0)
        }
    });
    return out;
  }
  scenariosYear() {
    let out = this.scenarios().reduce((acc,v,idx) => {
      let i = Math.floor(idx / 12);
      //console.log('index',i);
      if (!acc[i]) {
        acc[i] = {name:i+1,interestA:0,interestB:0,yieldA:0,yieldB:0};
      }
      acc[i].interestA += v.interestA;
      acc[i].interestB += v.interestB;
      acc[i].yieldA += v.yieldA;
      acc[i].yieldB += v.yieldB;
      return acc;
    },new Array(30).fill(false));
    console.log('scenariosYear',out);
    return out;
  }
  outOfDebt() {
    // months until out of debt each approach
    let out = [{networthA:40,networthB:120}];
    out[0].networthA = this.props.resultA.reduce((acc,r,month) => acc < 0  && r.debts.reduce((acc2,d) => acc2 + d.principal,0) <=0 ? month : acc ,-1);
    out[0].networthB = this.props.resultB.reduce((acc,r,month) => acc < 0  && r.debts.reduce((acc2,d) => acc2 + d.principal,0) <=0 ? month : acc ,-1);
    
    return out;
  }
  outDebtCaption(monthsAway) {
    var today = new Date();
    var newDate = new Date(today.setMonth(today.getMonth()+monthsAway));
    if (monthsAway === -1) {
      return "Never";
    } else {
      return newDate.toLocaleString('default', { month: 'long', year:'numeric' }).split(/,/)[0];
    }

  }
  monthsAdd(monthsAway) {
    var today = new Date();
    var newDate = new Date(today.setMonth(today.getMonth()+monthsAway));
    return newDate.toLocaleString('default', { month: 'long', year:'numeric' }).split(/,/)[0];
  }
  approach() {
    return this.props.approach.charAt(0).toUpperCase() + this.props.approach.substr(1);
  }
  render() {
    
  return (
    <div>
      <ResponsiveContainer width="100%" height={240}>
        <BarChart width={150} height={240} data={this.outOfDebt()} layout="vertical" margin={{
            top: 10,
            right: 10,
            left: 30,
            bottom: 60
          }}>
          <XAxis  type="number"  tickFormatter={(v) => v/12} ticks={[0,60,120,180,240,300,360]} domain={[0, 360]} label={{value: 'Years Until Out of Debt',offset:-10,position:'insideBottom'}}/>
          <YAxis dataKey="name" type="category" />
          <Tooltip formatter={this.outDebtCaption}/>
          <Legend verticalAlign="top" height={36}/>
          <Bar dataKey="networthA"   fill="hsl(10, 85%, 58%)"  name={this.approach() + ' Approach'} />
          <Bar dataKey="networthB" fill="hsl(34, 93%, 62%)" name="Current Approach" />
        </BarChart>
      </ResponsiveContainer>
      
      {1===2 && <ResponsiveContainer width="100%" height={500}>
        <BarChart width={150} height={500} data={this.scenariosYear()}  stackOffset="sign" margin={{
            top: 10,
            right: 10,
            left: 30,
            bottom: 60
          }}>
          <YAxis  type="number"  tickFormatter={DataFormater}  label={{ value: 'Interest & Yields ($)', angle: -90, position: 'insideLeft',offset:-10  }}  />
          <XAxis dataKey="name" ticks={[1,5,10,15,20,25,30]} type="category" >
            <Label value="Years" offset={-10}  position="insideBottom" />
          </XAxis>
          <Tooltip formatter={DataFormater} labelFormatter={(n) => 'Year ' + n}/>
          
          <ReferenceLine y={0} stroke="#000" />
          <Bar dataKey="yieldA"   fill="hsl(10, 85%, 58%)"  stackId="a" name={this.approach() + ' Yield'} />
          <Bar dataKey="yieldB" fill="hsl(34, 93%, 62%)" stackId="b" name="Current Approach Yield" />
          <Bar dataKey="interestA"   fill="hsl(10, 85%, 58%)"  stackId="a" name={this.approach() + ' Interest'} />
          <Bar dataKey="interestB" fill="hsl(34, 93%, 62%)" stackId="b" name="Current Approach Interest" />
        </BarChart>
      </ResponsiveContainer>}

      <ResponsiveContainer width="100%" height={500}>
        <AreaChart
          width={300}
          height={400}
          data={this.scenarios()}
          margin={{
            top: 10,
            right: 10,
            left: 30,
            bottom: 60
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month"  interval={59}  tickFormatter={(v) => v/12}>
            <Label value="Years" offset={-10}  position="insideBottom" />
          </XAxis>  
          <YAxis type="number" tickFormatter={DataFormater} label={{ value: 'Net Worth ($)', angle: -90, position: 'insideLeft',offset:-10 }}/>
          <Legend verticalAlign="top" height={36}/>
          <Tooltip formatter={DataFormater} labelFormatter={this.monthsAdd}/>
          <Area type="monotone" dataKey="networthA" stroke="hsl(10, 85%, 58%)" name={this.approach() + ' Approach'} fill="hsl(10, 85%, 58%)" />
          <Area type="monotone" dataKey="networthB" stroke="hsl(34, 93%, 62%)" name="Current Approach" fill="hsl(34, 93%, 62%)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
    }
}

/**************************
    //// CLASS FinCalc ////
**************************/
class FinCalc extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  dollar(val) {   
    let out = parseFloat(val.replace(/[^.0-9]/g,''));
    if (!out && out !== 0) {
      out = '';
    }
    return out;

  }
  k($val) {
    return this.money($val/1000) + 'k';
  }

  money(val) {
    //if (!val) return '';
    return '$' + parseInt((val ?? 0)).toLocaleString(); 
  }

  monthsYears(m) {
    if (m>56) {
      return Math.round(m/12) + 'y';
    }
    return m + 'm';
  }

}  
/******************************
    //// CLASS DebtEditRow ////
******************************/
class DebtEditRow extends FinCalc {

  padIndex() {
    var out =  this.props.index + 1;
    out = out < 10 ? '0' + out : out;
    return out ;
  }

  update = (updIndex,newVal) => {
    var out = this.props.debt;
    if (newVal.replace(/[-0-9. ]/g,'').length === 0 && Math.abs(parseFloat(newVal))>0) {
      newVal = parseFloat(newVal);
    }
    out[updIndex] = newVal; 
    this.props.onChange?.(out);
  }

  render() {
    return(<tbody><tr className="debtEditRow">
      <td><button onClick={() => this.props.onConfirm?.()}><span class="material-icons-outlined">check</span></button></td>
      <td><button onClick={() => this.props.onRemove?.()}><span class="material-icons-outlined">delete</span></button></td>
      <td><br /></td>
      {1===2 && <td>{this.padIndex()}</td>}
      <td>Debt Name
        <div className="describe">A title which describes this debt</div>
        <input type="text" value={this.props.debt.name} size={16} onChange={(ev) => this.update('name',ev.target.value)}/>
      </td>
      <td>Amount Remaining
        <div className="describe">The amount which you still owe as of today</div>
        <input type="text" value={this.props.debt.principal} size={8} onChange={(ev) => this.update('principal',ev.target.value)}/></td>
      <td>Interest
        <div className="describe">The annual rate as a decimal, for example,  7% is 0.07</div>
        <input type="text" value={this.props.debt.interest} size={6} onChange={(ev) => this.update('interest',ev.target.value)}/></td>
      <td>
        Minimum Payment
        <div className="describe">If required to make a minimum monthly payment on this debt, or 0</div>
        <input type="text" value={this.props.debt.paymentMin} size={4} onChange={(ev) => this.update('paymentMin',ev.target.value)}/></td>
      <td>
        Actual Payment
        <div className="describe">The amount you pay monthly to service this debt</div>
        <input type="text" value={this.props.debt.paymentMonthly} size={4} onChange={(ev) => this.update('paymentMonthly',ev.target.value)}/></td>
      <td>
        Services Asset
        <div className="describe">If debt is for an item listed in your assets, like a car or home, select below</div>
        <select onChange={(ev) => this.update('investmentIndex',ev.target.value)} value={this.props.debt.investmentIndex}><option value={-1}>none</option>
      {this.props.investments.map((i,idx) => <option value={idx} >{i.name}</option>)}
      </select></td>
    </tr></tbody>);
  }

}
/******************************
    //// CLASS DebtListRow ////
******************************/
class DebtListRow extends DebtEditRow {

  render() {
    return(<tbody className="listOption"><tr  className={['investListRow','vBot',this.props.index % 2 && 'alt'].join(' ')} onClick={() => this.props.onSelect?.(this.props.index)}>
      <td >{this.padIndex()}</td>
      <td colSpan={6}><strong>{this.props.debt.name}</strong></td>
      </tr>
      <tr className={['investListRow','vTop',this.props.index % 2 && 'alt'].join(' ')} onClick={() => this.props.onSelect?.(this.props.index)}>
        <td></td>
      <td>{this.k(this.props.debt.principal)}</td>
      <td>+${this.props.debt.paymentMonthly}/mo.</td>
      <td className="txtR">{Math.round(this.props.debt.interest * 100)}%</td>
    </tr>
    </tbody>);
  }

} 
/*******************************
    //// CLASS InvestEditRow ////
*******************************/
class InvestEditRow extends FinCalc {

  padIndex() {
    var out =  this.props.index + 1;
    out = out < 10 ?  '0' + out : out;
    return out ;
  }

  update = (updIndex,newVal) => {
    var out = this.props.investment;
    if (newVal.replace(/[-0-9. ]/g,'').length === 0 && Math.abs(parseFloat(newVal)) > 0) {
      newVal = parseFloat(newVal);
    }
    out[updIndex] = newVal;
    this.props.onChange?.(out);
  }

  render() {
    return(<tbody><tr className="investEditRow">
      <td><button onClick={() => this.props.onConfirm?.()}><span class="material-icons-outlined">check</span></button></td>
      <td><button onClick={() => this.props.onRemove?.()}><span class="material-icons-outlined">delete</span></button></td>
      <td><br /></td>
      {1===2 && <td>{this.padIndex()}</td>}
      <td>Name
        <div className="describe">A title which describes this asset</div>
        <input type="text" value={this.props.investment.name} placeholder="Name" size={16} onChange={(ev) => this.update('name',ev.target.value)}/></td>
      <td>Appreciation
        <div className="describe">The average rate this assets gains or losses value over a year</div>
        <input type="text" value={this.props.investment.appreciation} placeholder="%" size={6} onChange={(ev) => this.update('appreciation',ev.target.value)}/></td>
      <td>Principal
        <div className="describe">The current value of this asset</div>
        <input type="text" value={this.props.investment.principal} placeholder="Principal $" size={8} onChange={(ev) => this.update('principal',ev.target.value)}/></td>
      <td>Contribution
        <div className="describe">The amount of money you add to this asset yearly</div>
        <input type="text" value={this.props.investment.contribution} placeholder="$" size={4} onChange={(ev) => this.update('contribution',ev.target.value)}/>
      </td>

      <td>Retirement Account?
        <div className="describe">Is this an employer-sponsored or individual retirement account?</div>
        {(this.props.investment.retirementAcct > 0 && <span className="material-icons-outlined button on" onClick={() => this.update('retirementAcct',0)}>toggle_on</span>) || <span className="material-icons-outlined button off" onClick={() => this.update('retirementAcct',1)}>toggle_off</span>}
      </td>
      {this.props.investment.retirementAcct > 0 && <React.Fragment>
        <td>Match Rate
          <div className="describe">If your employer matches a portion of your annaul contribution to this asset</div>
          <input type="text" value={this.props.investment.matchRate} placeholder="%" size={4} onChange={(ev) => this.update('matchRate',ev.target.value)}/></td>
        <td>Match Maximum
          <div className="describe">If your employer matches, enter the limit of their contribution</div>
          <input type="text" value={this.props.investment.matchMax} size={8} onChange={(ev) => this.update('matchMax',ev.target.value)}/></td>
        <td>Tax Relief?
          <div className="describe">Do contributions to this asset lower your tax burden</div>
          {(this.props.investment.taxRelief > 0 && <span className="material-icons-outlined button on" onClick={() => this.update('taxRelief',0)}>toggle_on</span>) || <span className="material-icons-outlined button off" onClick={() => this.update('taxRelief',1)}>toggle_off</span>}
        </td>
      </React.Fragment>}
    </tr></tbody>);
  }

  renderOld() {

    return(<tr >
      <td>{this.padIndex()}</td>
      <td><input type="text" value={this.props.investment.name} placeholder="Name" size={16} onChange={(ev) => this.update('name',ev.target.value)}/></td>
      <td><input type="text" value={this.props.investment.principal} placeholder="Principal $" size={8} onChange={(ev) => this.update('principal',ev.target.value)}/></td>
      <td><input type="text" value={this.props.investment.contribution} placeholder="$" size={4} onChange={(ev) => this.update('contribution',ev.target.value)}/></td>
      <td><input type="text" value={this.props.investment.matchRate} placeholder="%" size={4} onChange={(ev) => this.update('matchRate',ev.target.value)}/></td>
      <td><input type="text" value={this.props.investment.matchMax} size={8} onChange={(ev) => this.update('matchMax',ev.target.value)}/></td>
      <td><input type="text" value={this.props.investment.appreciation} placeholder="%" size={6} onChange={(ev) => this.update('appreciation',ev.target.value)}/></td>
      <td>{(this.props.investment.taxRelief > 0 && <button onClick={() => this.update('taxRelief',0)}>Y</button>) || <button onClick={() => this.update('taxRelief',1)}>N</button>}</td>
      <td><button onClick={() => this.props.onRemove?.()}><span class="material-icons-outlined">delete</span></button></td>
    </tr>);
  }

}
/*******************************
    //// CLASS InvestListRow ////
*******************************/
class InvestListRow extends InvestEditRow {

  render() {
    return(<tbody className="listOption"><tr onClick={() => this.props.onSelect?.(this.props.index)}  className={['investListRow','vBot',this.props.index % 2 && 'alt'].join(' ')}>
      <td >{this.padIndex()}</td>
      <td colSpan={6}><strong>{this.props.investment.name}</strong></td>
      </tr>
      <tr onClick={() => this.props.onSelect?.(this.props.index)} className={['investListRow','vTop',this.props.index % 2 && 'alt'].join(' ')}>
        <td></td>
      <td>{this.k(this.props.investment.principal)}</td>
      <td>+${this.props.investment.contribution}/mo.</td>
      <td className="txtR">{Math.round(this.props.investment.appreciation * 100)}%</td>
      {1===2 && <td>{this.props.investment.matchMax>0 && <div>{'MATCH$' + this.props.investment.matchMax}</div>} 
      {(this.props.investment.taxRelief > 0 && <span>TAXFREE</span>) || <span onClick={() => this.update('taxRelief',1)}></span>}</td>}
    </tr>
    </tbody>);
  }

} 
/*******************************
    //// CLASS DebtInvestGraph ////
*******************************/
class DebtInvestGraph extends React.Component {
  
  start() {
    return this.formatDlrs(this.props.start);
  }
  
  enda() {
    return this.formatDlrs(this.props.enda);
  }

  endb() {
    return this.formatDlrs(this.props.endb);
  }

  formatDlrs(dlrs) {
    if (Math.abs(dlrs) > 100000000) {
      dlrs = (dlrs/1000000000).toFixed(1) + 'B'
    } else if (Math.abs(dlrs) > 1000000) {
      dlrs = (dlrs/1000000).toFixed(1) + 'M'
    } else if (Math.abs(dlrs) > 1000) {
      dlrs = (dlrs/1000).toFixed(0) + 'k'
    }
    return dlrs;
  }

  yTop() {
    return 40;
  }

  yPosEnda() {
    return this.props.enda >= this.props.endb ? this.yTop() : this.yAbs(this.props.enda);
  }

  yPosEndb() {
    return this.props.enda <= this.props.endb ? this.yTop() : this.yAbs(this.props.endb);
  }

  min() {
    return [0,this.props.start,this.props.enda,this.props.endb].sort((a,b)=>a-b)[0];
  }

  max() {
    return [0,this.props.start,this.props.enda,this.props.endb].sort((a,b)=>a-b).reverse()[0];
  }

  range() {
    return this.max() - this.min();
  }

  yAbs(val) {
    let mod = (600-140);// * ((val - this.min()) / this.range());
    var dist = [this.max() - val,this.min() + val].map(v => v / this.range());
    // console.log('yAbs','range',this.range(),'min',this.min(),'max',this.max(),'val',val,'dist',dist);
    return  mod * dist[0] ;
  }

  markerA() {
    var out = this.props.markera;
    console.log('markera',out);
    if (out > 1) {
      out = 1;
    } 
    if (out < 0) {
      out =1;
    }
    return out;
  }

  markerB() {
    var out = this.props.markerb;
    console.log('markerb',out);
    if (out > 1) {
      out = 1;
    } 
    if (out < 0) {
        out =1;
    }
    return out;
  }

  finalYear() {
    var today = new Date();
    var newDate = new Date(today.setMonth(today.getMonth()+ 30 * 12));
    return newDate.getFullYear();
  }

  render () {return (<svg width="100%"   viewBox={[0,0,720,600]}>  
  <g style={{ fill:'hsl(109, 3%, 10%)'}}>
    <rect height={600 - 140} width={1} x={60} y={20}></rect>
    <rect width={720 - 40} height={1} x={60} y={600 - 120}></rect>
  </g>  
  
  
  {Math.abs(this.props.enda) > Math.abs(this.props.endb)  && <polygon points={[[66,this.yAbs(this.props.start)], [720 - 6 ,this.yAbs(this.props.start)] ,[720 - 6,this.yPosEnda()]]} style={{fill:'hsla(10, 86%, 58%,1)'}} />}
  <polygon points={[[66,this.yAbs(this.props.start)], [720 - 6 ,this.yAbs(this.props.start)] ,[720 - 6,this.yPosEndb()]]} marksinput="b" style={{fill:'hsla(34, 94%, 62%,1)'}} />
  {Math.abs(this.props.enda) <=  Math.abs(this.props.endb) && <polygon points={[[66,this.yAbs(this.props.start)], [720 - 6 ,this.yAbs(this.props.start)] ,[720 - 6,this.yPosEnda()]]} style={{fill:'hsla(10, 86%, 58%,1)'}} />}

  <rect x={122-60} y={this.yPosEnda() - 36} width={60} height={40}  rx={7} style={{fill:'hsl(10, 86%, 58%)'}}  />
  <text x={122 -2} y={this.yPosEnda() -10} width={100} height={100} style={{fill:'hsl(109, 3%, 100%)',fontSize : 18,fontWeight:'bold'}} textAnchor="end">${this.enda()}</text>

  <rect x={0} y={this.yPosEndb() - 36} width={58} height={40}  rx={7} style={{fill:'hsl(34, 94%, 62%)'}}  />
  <text x={60 -2} y={this.yPosEndb() -10} width={100} height={100} style={{fill:'hsl(109, 3%, 10%)',fontSize: 18,fontWeight:'bold'}} textAnchor="end">${this.endb()}</text>

  <text x={60 -2} y={this.yAbs(0) -10} width={100} height={100} style={{fill:'hsl(109, 3%, 10%)',fontSize : 20}} textAnchor="end">$0</text>
  <line x1={66} y1={this.yAbs(0) -1} x2={720 - 12} y2={this.yAbs(0) -1}  style={{stroke:'hsl(109, 3%, 10%)',strokeWidth:4}} strokeDasharray="8 2" />
  <text x={60 -2} y={this.yAbs(this.props.start)-10} width={100} height={100} style={{fill:'hsl(109, 3%, 10%)',fontSize : 20}} textAnchor="end">${this.start()}</text>

  

  {this.markerA() && <g>
    {1===2 && this.markerA() < 1 && <line x1={720 * this.markerA() - 4} y1={600-85} x2={720 * this.markerA() -4} y2={600-115}  style={{stroke:'hsl(10, 86%, 58%)',strokeWidth:4}} strokeDasharray="6 2" />}
    {this.markerA() < 1 && <rect x={66} y={600-100} width={720 * this.markerA() -70} height={15}  style={{fill:'hsl(10, 86%, 58%)'}}  />}
    <rect x={20} y={600 -50} width={40} height={28} style={{fill:'hsl(10, 86%, 58%)'}} ></rect>
    <text x={720 * .5} y={600-30} width={100} height={100} style={{fill:'hsl(10, 86%, 58%)',fontSize : 26,textAnchor:'middle'}}>{this.props.markeraText}</text>
  </g>}

  {this.markerB() &&<g>
    {1===2 && this.markerB() < 1 && <line x1={720 * this.markerB() - 4} y1={600-85} x2={720 * this.markerB() -4} y2={600-115}  style={{stroke:'hsl(34, 94%, 62%)',strokeWidth:4}} strokeDasharray="6 2" />}
    {this.markerA() < 1 && <rect x={66} y={600-115} width={720 * this.markerB() -70} height={15}  style={{fill:'hsl(34, 94%, 62%)'}}  />}
    <rect x={20} y={600 - 80} width={40} height={28} style={{fill:'hsl(34, 94%, 62%)'}} ></rect>
    <text x={720 * .5} y={600 - 60} width={100} textAnchor="middle" height={100} style={{fill:'hsl(34, 0%, 12%)',fontSize : 26,textAnchor:'middle'}}>{this.props.markerbText}</text>
  </g>}

  
  <text x={62} y={600-90} width={100} height={100} style={{fill:'hsl(109, 3%, 10%)',fontSize : 20}}>{new Date().getFullYear()}</text>
  <text x={720-20} y={600-90} width={100} height={100} style={{fill:'hsl(109, 3%, 10%)',fontSize : 20}} textAnchor="end">{this.finalYear()}</text>
  

</svg>);}

}

class DebtInvest extends FinCalc {
  constructor(props) {
    super(props);
    this.state = {investments:this.demoInvestments(), debts: this.demoDebts(), contributionInterval:12, compoundInterval:1, editInvestRow:-1,editDebtRow:-1, debtMode : 'snowball'};
  }
  demoInvestments() {
    return [
      this.investment({name:'Primary Residence',principal:650000,contribution:0, appreciation:0.04}),
      this.investment({name:'Stocks',principal:45000,contribution:200, appreciation:0.07}),
      this.investment({name:'Employer 401K',principal:106000,contribution:1500, appreciation:0.06,retirementAcct:1,matchRate:0.25,matchMax:200,taxRelief:1}),
      this.investment({name:'Cryptocurrency',principal:2800,contribution:50, appreciation:0.06}),
      this.investment({name:'Car',principal:22000,contribution:0, appreciation:-0.1}),
    ];
  }
  demoDebts() {
    return [this.debt({name:'Home Mortgage',principal:250000,paymentMonthly:1200,paymentMin:1200, interest:0.035,investmentIndex:0})
    ,this.debt({name:'Auto Loan',principal:16500,paymentMonthly:400,paymentMin:340, interest:0.08,investmentIndex:4})
    ,this.debt({name:'Credit Card Loan',principal:22000,paymentMonthly:200,paymentMin:200, interest:0.16})
    ,this.debt({name:'Unpaid Taxes',principal:8500,paymentMonthly:900,paymentMin:200, interest:0.04})
  ];
  }
  formatDlrs(dlrs) {
    if (Math.abs(dlrs) > 100000000) {
      dlrs = (dlrs/1000000000).toFixed(1) + 'B'

    } else if (Math.abs(dlrs) > 1000000) {
      dlrs = (dlrs/1000000).toFixed(1) + 'M'
    } else if (Math.abs(dlrs) > 1000) {
      dlrs = (dlrs/1000).toFixed(0) + 'k'
    }

    return dlrs;
  }
  investment(params) {
    return {
      name : params?.name || 'unnamed investment',
      principal : params?.principal || 10000,
      contribution : params?.contribution || 0,
      appreciation : params?.appreciation || .04,
      retirementAcct : params?.retirementAcct || 0,
      matchRate : params?.matchRate || 0,
      matchMax : params?.matchMax || 0,
      taxRelief : params?.taxRelief || 0,
      monthValue() {
      
      },
      fv : function(nper)
      {
        var per = 12;
        nper = parseFloat(nper);
        var pmt = parseFloat(this.contribution ) * -1;
        var pv = parseFloat(this.principal) * -1;
        var rate = eval((this.appreciation * 100)/(per * 100));
        
        var fv_value = 0;
        if ( rate === 0 ) // Interest rate is 0
        {
          fv_value = -(pv + (pmt * nper));
        } else {

          var x = Math.pow(1 + rate, nper);
          // y = Math.pow(1 + rate, nper);
          fv_value = - ( -pmt + x * pmt + rate * x * pv ) /rate;
        }
        fv_value = this.conv_number(fv_value,2);
        return (fv_value);
    },
      matchedContribution(contrib) {
        if (!contrib) {
          contrib = this.contribution
        }
        var out = contrib * this.matchRate;
        return out > this.matchMax ? this.matchMax : out;
      },
      fullContribution() {
        return this.contribution + this.matchedContribution();
      },
      total(timeInterval,compoundTimes,contributionTimes) {
        // P is principal , r is rate, t is time in years, pmt is contribution,  n is compound frequency , cn is contribution frequency, frequencies/intervals represented as 1,12,365,52
        var part =  (1 + this.appreciation/compoundTimes);
        var A = this.principal * Math.pow(part,(compoundTimes * timeInterval));
        console.log('invesment total',A,part);
        A+= this.contribCompounded(timeInterval, contributionTimes) ;
        return parseFloat(A.toFixed(2));
      },
      contribCompounded(timeInterval,contributionTimes) {
        
          var out = ((timeInterval * contributionTimes) * this.fullContribution());
          console.log('contrib,compounded 1', out) ;
          if (this.appreciation > 0) {
            out =  this.fullContribution() * (((Math.pow((1 + this.appreciation / contributionTimes), timeInterval * contributionTimes)) - 1) / (this.appreciation / contributionTimes));
            console.log('contrib,compounded 2', out) ;
          } 
         console.log('contrib,compounded m3', out) ;
          return out;
      },
      conv_number:function(expr, decplaces)
      { // This function is from David Goodman's Javascript Bible.
      var str = "" + Math.round(eval(expr) * Math.pow(10,decplaces));
      while (str.length <= decplaces) {
      str = "0" + str;
      }
      var decpoint = str.length - decplaces;
      return (str.substring(0,decpoint) + "." + str.substring(decpoint,str.length));
      }

    };
    
  }
  debt(params) {
    return {
      name : params?.name || 'unnamed debt',
      interest : params?.interest || 0.05,
      principal : params?.principal || 10000,
      paymentMonthly : params?.paymentMonthly || 300,
      paymentMin:params?.paymentMin || 300,
      investmentIndex:params?.investmentIndex,
      remainMonths: function () { 
        //http://www.mohaniyer.com/old/js.htm#fv
        
        return Math.round(this.nper(12,this.paymentMonthly,this.principal * -1,0));
      },
      totalCost: function() {
        // time to pay off , principal, interest 

      },
      fv : function(nper)
      {
        var per = 12;
        nper = parseFloat(nper);
        var pmt = parseFloat(this.paymentMonthly ) * -1 ;
        var pv = parseFloat(this.principal) ;
        var rate = eval((this.interest * 100)/(per * 100));
        
        var fv_value = 0;
        if ( rate === 0 ) // Interest rate is 0
        {
          fv_value = -(pv + (pmt * nper));
        } else {

          var x = Math.pow(1 + rate, nper);
          // y = Math.pow(1 + rate, nper);
          fv_value = - ( -pmt + x * pmt + rate * x * pv ) /rate;
        }
        fv_value = this.conv_number(fv_value,2);
        if (fv_value > 0 ) {
          fv_value = 0;
        }
        return (fv_value * -1);
    },
      surplus: function() {
        return this.paymentMonthly - this.paymentMin;
      },
      nper : function ( per, pmt, pv, fv) {
        fv = parseFloat(fv);  
        pmt = parseFloat(pmt);
        pv = parseFloat(pv);
        per = parseFloat(per);

        if (( per === 0 ) || ( pmt === 0 )){
          //alert("Why do you want to test me with zeros?");
          return(0);
        }
        var rate = this.interest;
        rate = eval((rate * 100)/(per * 100));
        var nper_value = 0;
        if ( rate == 0 ) // Interest rate is 0
        {

          nper_value = - (fv + pv)/pmt;

        } else
        {

        nper_value = Math.log((-fv * rate + pmt)/(pmt + rate * pv))/ Math.log(1 + rate);

        }

        nper_value = this.conv_number(nper_value,2);

      return (nper_value);

},
    conv_number:function(expr, decplaces)

    { // This function is from David Goodman's Javascript Bible.
    var str = "" + Math.round(eval(expr) * Math.pow(10,decplaces));
    while (str.length <= decplaces) {
    str = "0" + str;
    }
    var decpoint = str.length - decplaces;
    return (str.substring(0,decpoint) + "." + str.substring(decpoint,str.length));
    }
    };
  }
  addInvest = () => {
    var hold = this.state.investments;
    hold.push(this.investment());
    this.setState({investments : hold, editInvestRow: hold.length - 1});
  }
  addDebt = () => {
    var hold = this.state.debts;
    hold.push(this.debt());
    this.setState({debts : hold, editDebtRow: hold.length - 1});
  }
  remDebt = (remIndex) => {
    var hold = this.state.debts;
    this.setState({editDebtRow:-1, debts : hold.filter((item,idx) => idx !== remIndex)});
  }
  remInvest = (remIndex) => {
    var hold = this.state.investments;
    this.setState({editInvestRow:-1,investments : hold.filter((item,idx) => idx !== remIndex)});
  }

  updDebt = (updIndex, newVal) => {
    console.log('debt update', updIndex, 'val',newVal);
    var hold = this.state.debts;
    hold[updIndex] = newVal;
    this.setState({debts : hold});
  }
  updInvest = (updIndex, newVal) => {
    var hold = this.state.investments;
    hold[updIndex] = newVal;
    this.setState({investments : hold});
  }
  investSubtotal(months) {
    // loop investments with gain calculator over months
    var out = 0;
    return out;
  }
  investTotal(months) {
    var curTotal = this.state.investments.reduce((acc,item) => acc + parseFloat(item.fv(months)),0);
    return curTotal;
  }
  debtTotal(months) {
    var curTotal = this.state.debts.reduce((acc,item) => acc + parseFloat(item.fv(months)),0) * -1;
    return  curTotal;
  }
  payDebt(surplus,debtPriority) {
      // take the amt remain from the next priority item
      // locate the targeted debt, pay as much from surplus as can
      // update the located debt
      // return the remaining surplus amount 

      var nextAmt = debtPriority.principal;
      var surplusLeft = surplus;
      var remain = nextAmt - surplusLeft;
      if (remain < 0) {
        nextAmt = 0;
      } else {
        nextAmt = remain;
      }
      return surplusLeft;
  }
  /*
    1. user define
      a. pay as defined
      b. shift surplus of paid off debts to highest interest
    2. avalanche
      a. shift surplus to highest return/interest
    3. snowball
      a. pay debts first, lowest amount
      b. shift surplus to lowest amt debt
      c. shift paid-off surplus to lowest amt debt

  payRequired() // user-define or mins+no-invest
  calculateSurplus() // fulfilled debts, non require
  allocateSurplus() // lowest debt, or based on interest   

  */

  simulate(months, simMode = 'neutral')  {
    // run a monthly simulation allocating the surplus as designated
    // simMode will either be: neutral (user-define), avalanche (based on interest/appreciation), snowball (debts first starting w lowest amount)
    // this will give a simple amount of flexibility into this process of paying bills and investing surplus

    var monthResults = []; // return an array for the values for each month of the simulation to query later 

    var debtPriority = this.state.debts.map((v,idx) => [idx,v,'debt']); // these should updated simulated values through the duration of the simulations
    var investPriority = this.state.investments.map((v,idx) => [idx,v,'investment']); // max the index as the first element to maintain through sorting
    
    // need a total for each debt and each investment
    // use surplus to contribute to each priority until debts are repaid 

    // get the idx with the sorted array rank
    
    for (var m = 0; m < months; m++){
      if (m === 0 ) {
        // first month of simulation
        var lastMonth = {debts: this.state.debts.map(d => {return {principal : d.principal,surplusPayment:0}}), 
          investments:this.state.investments.map(d => {return {principal : d.principal,surplusPayment:0}})
          ,surplus: this.surplus() };
      } else {
        // after first month
        var lastMonth = monthResults[m-1];
      }

      // accumulate the interest and payment for each
      var thisMonth =  { 
        debts:  lastMonth.debts.map(   (d,idx) => {return {priority:-1, interest: this.state.debts[idx].interest, surplusPayment:0, interestPaid: d.principal * (this.state.debts[idx].interest/12),principal : d.principal * (1+this.state.debts[idx].interest/12) }})
        ,investments: lastMonth.investments.map(   (i,idx) => {return {priority:-1, appreciation:this.state.investments[idx].appreciation,surplusPayment:0, yield:i.principal * (this.state.investments[idx].appreciation/12), principal : i.principal * (1+this.state.investments[idx].appreciation/12) }})
        ,surplus: lastMonth.surplus
      };

      // gather surplus for this month which should reflect minimum from paid off debts
      // here is the surplus calculation, notice it includes the full contribution
      var surplusRemain =  this.state.debts.reduce((acc,d,debtIdx) => thisMonth.debts[debtIdx].principal <=0 ? acc + d.paymentMonthly : acc,0);   // paid off debts
      if(simMode !== 'neutral') {
        surplusRemain += this.state.debts.reduce((acc,d,debtIdx) => thisMonth.debts[debtIdx].principal <=0 ? acc : acc+d.surplus(),0); //debt payments above minumum
        surplusRemain += this.state.investments.reduce((acc,i,invIdx) => acc+i.contribution,0); // investment contributions
      }
      
      // PAY OBLIGATIONS (ALL simModes)
      // match the index values in these arrays to the indexes returned from the priority sorting
      // apply each debt and investment minimum until zero, emptied should add more surplus for next time
      thisMonth.debts.forEach((d,idx) => {
          if (d.principal > 0) {
            if (this.state.debts[idx].paymentMin > d.principal) {
              // add leftover to surplus
              surplusRemain += this.state.debts[idx].paymentMin - d.principal;
              d.principal = 0;
            } else {
              d.principal -= this.state.debts[idx].paymentMin;
            }
          } else {
            // already collected paid debts into surplus above
          }
          d.thisMinPay = this.state.debts[idx].paymentMin;
      });
      // update surplus here based on all debts paid 
      thisMonth.surplus = surplusRemain;

      // INVEST OBLIGATIONS user-defined
      if(simMode === 'neutral') {
        thisMonth.investments.forEach((d,idx) => {
          // don't always make all the contributions because that figure is applied to the surplus
          // maybe only matched contributions are included under normal emphasis - do we have designated minium allocations for investments?
          d.thisContrib = this.state.investments[idx].contribution + this.state.investments[idx].matchedContribution();
          d.principal += this.state.investments[idx].contribution + this.state.investments[idx].matchedContribution();
        });
      }

      // ALLOCATE SURPLUS FUNDS based on simMode

      if (simMode === 'snowball') {
        debtPriority.sort((a,b) => a[1].principal - b[1].principal );
        
        //console.log('debt priority',debtPriority);
        var debtIdx = 0;
        do {
          let payIdx = debtPriority[debtIdx]?.[0];
          if (!payIdx && payIdx !== 0) {
            break;
          }
          // TODO: two kinds of surplus, that from repaid debts and that from current debts above the minPayment
          // if any surplus apply to debts
          if (surplusRemain > 0 && thisMonth.debts[payIdx]?.principal > 0){
            if (surplusRemain > thisMonth.debts[payIdx].principal) {
              // if surplus remain then paid off
              surplusRemain = surplusRemain - thisMonth.debts[payIdx].principal;
              thisMonth.debts[payIdx].surplusPayment = thisMonth.debts[payIdx].principal;
              thisMonth.debts[payIdx].principal = 0;
              // increase next cycle surplus because this one is zeroed out minPayment
            } else {
              // apply all the surplus
              thisMonth.debts[payIdx].principal = thisMonth.debts[payIdx].principal - surplusRemain;
              thisMonth.debts[payIdx].surplusPayment = surplusRemain;
              surplusRemain = 0;
            }
          }
          thisMonth.debts[payIdx].priority = debtIdx; // save the priority
          debtIdx++; // move on to the next item
        } while (debtIdx < thisMonth.debts.length ) //while (surplusRemain > 0)
         
      } 
      if (surplusRemain > 0) {
          //effectively includes simMode===neutral/avalanche or snowball once all debt is fulfilled

          // allocate to highest yield, whether debt or investment
          investPriority.sort((a,b) =>  b[1].appreciation - a[1].appreciation ); 


          let allPriority = investPriority.concat(debtPriority); // combine investment/debts to sort together
          allPriority.sort((a,b) =>  (b[2] === 'debt' ? b[1].interest : b[1].appreciation) - (a[2] === 'debt' ? a[1].interest : a[1].appreciation) ); 
          
          // TODO add matchedContribution into priority calculation (something like "effective yield") untill maxed out
          // TODO reuse paydebt/investment logic  vis-a-vis principal, surplus

          var investIdx = 0;
          do {
            // TODO include matched contribution in here
            let payIdx = allPriority[investIdx][0];
            let payType  = allPriority[investIdx][2];
          
            if (surplusRemain > 0) {
              if (payType === 'debt') {

                if (thisMonth.debts[payIdx]?.principal > 0){
                  if (surplusRemain > thisMonth.debts[payIdx].principal) {
                    // if surplus remain then paid off
                    surplusRemain = surplusRemain - thisMonth.debts[payIdx].principal;
                    thisMonth.debts[payIdx].surplusPayment = thisMonth.debts[payIdx].principal;
                    thisMonth.debts[payIdx].principal = 0;
                    // increase next cycle surplus because this one is zeroed out minPayment
                  } else {
                    // apply all the surplus
                    thisMonth.debts[payIdx].principal = thisMonth.debts[payIdx].principal - surplusRemain;
                    thisMonth.debts[payIdx].surplusPayment = surplusRemain;
                    surplusRemain = 0;
                  }
                }

              } else {
                // investment
                thisMonth.investments[payIdx].principal +=  surplusRemain + this.state.investments[payIdx].matchedContribution(surplusRemain); 
                thisMonth.investments[payIdx].surplusPayment = surplusRemain;
                surplusRemain = 0;
              }
            }  
            if (payType === 'debt') {
              thisMonth.debts[payIdx].priority = investIdx; // save the priority
            } else {  
              // investment
              thisMonth.investments[payIdx].priority = investIdx; // save the priority
            }

            investIdx++; // move on to the next item
          } while (investIdx < allPriority.length )
      } 
      
      monthResults.push(thisMonth);
    }
    // start with the minimum 
    // sort debts/invest by relevant criteria
    // all remaining surplus goes to highest return investment
    // prioritize payment, save record of item at this scenario
    this.debtPriority = debtPriority;
    this.investPriority = investPriority;
    return monthResults;
  }

  portfolio(months) {
    // this will be the method where we pay debts first 
    return this.investTotal(months) + this.debtTotal(months);
  }

  portfolioAlt(months) {
    // TODO make this different than portfolio() method above
    // this will be the method where we pay min debt payments and invest more
    return this.investTotal(months) + this.debtTotal(months);
  }    

  payMonthly() {
    // this is not used? where is the formula which run this simulation? answer: portfolio/portfolioAlt
    var out =  [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(v => {return {
      name: 'Y' + v ,
      // minMonthlyPayment: this.monthlyMin()  *  12 * 1 * v,
      debtremain: this.state.debts.reduce((acc,d) => acc + (d.principal || 0),0) - this.monthlyMin() *  12 * 1 * v ,
      //surplusPayment:(this.monthlyMin() + this.surplus())   *  12 * 1 * v,
      surplusRemain:this.state.debts.reduce((acc,d) => acc + (d.principal || 0),0) - (this.monthlyMin() + this.surplus())  *  12 * 1 * v ,
    }} );
    out.forEach(v => {if (v.debtremain<=0) {v.debtremain=0} if (v.surplusRemain<=0) {v.surplusRemain=0}})
    return out;
  }

  surplus() {
    //payments after paying minimums
    // used to auto-allocate 
    //this.state.debts.sort((a,b) => a.paymentMin - b.paymentMin);
    return this.state.investments.reduce((acc,i) => acc+i.contribution,0) + this.state.debts.reduce((acc,d) => acc+d.surplus(),0);
  }

  monthlyMin() {
    return this.state.debts.reduce((acc,d) => acc+d.paymentMin,0);
  }

  selectRow = (idx) => {
    //console.log('selectRow',idx);
    this.setState({editInvestRow:idx});
  }

  selectDebtRow = (idx) => {
    //console.log('selectRow',idx);
    this.setState({editDebtRow:idx});
  }

  priority() {
    // use simulate results here to construct payment schedule

    // simulation adjustments: neutral, avalanche, snowball 
    var thisSim = this.simulate(30*12, this.state.debtMode);

    var debtSort = thisSim[0].debts.map((d,idx) => [idx,d.priority,'debt',d.interest]);
    var investSort = thisSim[0].investments.map((d,idx) => [idx,d.priority,'invest',d.appreciation]);
    

    debtSort.sort((a,b) => a[1] - b[1]);
    investSort.sort((a,b) => a[1] - b[1]);
    var combSort = debtSort.concat(investSort);
    combSort.sort((a,b) => { 
      var out = b[3] - a[3]; // interest sort
      return out;

    } );

    var out = [];
    // blend these debt/invesment values based on interest/return rate
    if (this.state.debtMode === 'avalanche') {
      out = combSort.map((d,idx) => d[2] === 'debt' ? this.debtPriorityRow(d,idx,thisSim) : this.investPriorityRow(d,idx,thisSim));
    } else {
      // snowball
      out = debtSort.map((d,idx) => this.debtPriorityRow(d,idx,thisSim));
      out = out.concat(investSort.map((d,idx) => this.investPriorityRow(d,idx,thisSim)));
    }
    return out;
  }

  investPriorityRow(d,idx,thisSim) {
    var mod = (this.state.debtMode === 'avalanche') ? 0 : this.state.debts.length;
    return (<tr>
      <td>{idx + mod + 1}</td>
      <td>{this.state.investments[d[0]].name}</td>
      <td className="txtR">$&nbsp;{this.formatDlrs(this.state.investments[d[0]].principal)}</td>
      <td className="txtR">-</td>
      <td className="txtR">{(this.state.investments[d[0]].appreciation * 100).toFixed(1)}%</td>
      </tr>);
  }

  debtPriorityRow(d,idx,thisSim) {
    
    return (<tr key={idx}>
      <td>{idx+1}</td>
      <td>{this.state.debts[d[0]].name}</td>
      <td className="txtR">$&nbsp;{this.formatDlrs(this.state.debts[d[0]].principal)}</td>
      <td className="txtR">{(this.state.debts[d[0]].interest * 100).toFixed(1)}%</td>
      <td className="txtR">-</td>
      {1===2 && <td className="txtR">{this.monthsRemain(thisSim, d[0])}</td>}</tr>);
  }

  monthsRemain(sim, debtIdx) {
    var m = sim.filter(s => s.debts[debtIdx].principal > 0).length;
    return  m + 'm';
  }

  outDebtCaption(monthsAway) {
    var today = new Date();
    var newDate = new Date(today.setMonth(today.getMonth()+monthsAway));
    if (monthsAway === -1) {
      return "never out of debt";
    } else {

      return " out " + newDate.toLocaleString('default', { month: 'long', year:'numeric' }).split(/,/)[0];
    }

  }

  sampleInvestments() {
var out = `commodity A     1.2     1.25    1.4%
REITS-index RGSIX      1.8     3       3.2%
gold             0.7     0.5     1.0%
index VTSAX         2.1     5.3     2.0%
index 500         2.3     5.7     7.0%
index VBTLX       1.7     4.5     7.3%
index VTI         1.7     4.5     7.3%
index FZROX         1.7     4.5     7.3%`;
  return out.split(/\n/g);
  }

  simResult(months,simType) {
    // simType will either be neutral(user defined), avalanche (by interest rate), snowball (debt first start w/ lowest principal)
    var thisSim = this.simulate(months,simType);
    var noDebtMonth = thisSim.reduce((acc,m,idx) => acc === -1 && m.debts.reduce((acc2,d) => acc2 + d.principal,0) === 0 ? idx : acc,-1);
    var simIdx = months - 1;
    simIdx = simIdx < 0 ? 0 : simIdx;
    var finalAssets = thisSim[simIdx].investments.reduce((acc,d) => acc+d.principal,0) - thisSim[simIdx].debts.reduce((acc,d) => acc+d.principal,0);
    return {debtfreeMonths:noDebtMonth, assets:Math.round(finalAssets)};

  }

  simulationGrid(months,simType = 'neutral') {
    var thisSim = this.simulate(months,simType);
    var noDebtMonth = thisSim.reduce((acc,m,idx) => acc === -1 && m.debts.reduce((acc2,d) => acc2 + d.principal,0) === 0 ? idx : acc,-1);
    var y30Index= (30 * 12 - 1);
    var finalAssets = thisSim[y30Index].investments.reduce((acc,d) => acc+d.principal,0) + thisSim[y30Index].debts.reduce((acc,d) => acc+d.principal,0);
    
    return( <table className="grid">
      <caption>Debt Free {noDebtMonth} in Months / 30 year assets {Math.round(finalAssets).toLocaleString()}</caption>
    <thead>
      <tr><th>Month</th><th>Surplus</th><th>Debts</th></tr>
    </thead>
    <tbody>
      {thisSim.map((v,idx) => <tr><td>mo. {idx}</td><td>{v.surplus}</td>
      {v.debts.map((d,dIdx) => <React.Fragment><td><div>debt</div>{dIdx}</td><td><div>priority</div>{d.priority}</td><td><div>surplus pay</div>{Math.round(d.surplusPayment)} </td><td><div>principal</div>{Math.round(d.principal)} </td><td><div>min</div>{Math.round(d.thisMinPay)}</td></React.Fragment>)}
      {v.investments.map((d,dIdx) => <React.Fragment><td><div>invest</div>{dIdx}</td><td><div>priority</div>{d.priority}</td><td><div>surplus pay</div>{Math.round(d.surplusPayment)}</td><td><div>principal</div>{Math.round(d.principal)}</td><td></td></React.Fragment>)}
    </tr>)}
    </tbody>
    </table>);
  }

  render() {
    
    return (<div className="debtInvest">
      {1===2 && <div>
        <h3>Next Month</h3>
        <div>{this.simResult(1).assets} assets</div>

        <h3>Debt First</h3>
        <div>{this.simResult(12*30).debtfreeMonths} till debt free</div>
        <div>{this.simResult(12*30).assets} 30y assets</div>
        <h3>Invest First</h3>
        <div>{this.simResult(12*100,false).debtfreeMonths} till debt free</div>
        <div>{this.simResult(12*30,false).assets} 30y assets</div>
      </div>}


      {1===2 && this.simulationGrid(30*12,'snowball')}
     

      <div className="reportInputs">

{1 === 2 && <h3>SELECT CONTRIBUTION <button>Monthly</button> <button>Yearly</button></h3>}

<div className="tip">Let's start by adding your assets and debts so we can determine the best approach to maximize your future net worth.</div>


{this.state.editDebtRow === -1 && <div className="fifty50">

{this.state.editInvestRow === -1 && <div>


<h2 className="txtC huge">ASSETS </h2>
<div className="guide txtC">Assets are items you own which gain or lose value over time.</div>
<h2><div className="huge">{this.k(this.investTotal(0))} </div>
</h2>
</div>}

<table className="accountTable">
  {this.state.editInvestRow !== -1 && <thead>
    {1===2 && <tr>
      <th></th>
      <th>Investment<br />Name</th>
      <th>Principal</th>
      <th>Contribution+</th>
      <th>Match<br />%</th>
      <th>Match<br />Maximum</th>
      <th>Annual <br />Return</th>
      <th>Tax<br />Relief</th>
    </tr>}
  </thead> || 
   <thead>
   <tr>
     <th></th>
     <th>Investment<br />Principal$</th>
     
     <th>Contribution+</th>
     <th>Return%</th>
     
   </tr>
 </thead>
  }
   
    {this.state.investments.map((inv,idx) => 
      this.state.editInvestRow === idx && <InvestEditRow investment={inv} onConfirm={() => this.setState({editInvestRow:-1})} index={idx} onChange={(newVal) => this.updInvest(idx,newVal)} onRemove={() => this.remInvest(idx)}/>  ||
      this.state.editInvestRow === -1 && <InvestListRow investment={inv} onSelect={this.selectRow} index={idx} onChange={(newVal) => this.updInvest(idx,newVal)} onRemove={() => this.remInvest(idx)}/>
      )
    }
    
  
</table>
{this.state.editInvestRow === -1 && <div className="txtC"><br /><button onClick={this.addInvest} className="small">Add Asset</button></div>}
</div>}


{this.state.editInvestRow === -1 &&  <div className="fifty50">
  {this.state.editDebtRow === -1 && <div> 
    
    <h2 className="txtC huge">DEBTS</h2>
    <div className="guide txtC">Debts are obligations you must pay over time, the cost increases with the amount of time it takes to pay it.</div>
    <h2><div className="huge">{this.k(this.debtTotal(0))}</div></h2>
  </div>}
<table className="accountTable selectList">
{this.state.editDebtRow !== -1 && <thead>
    {1 === 2 && <tr>
      <th></th>
      <th>Debt<br />Name</th>
      <th>Amount <br />Remaining</th>
      <th>Interest</th>
      <th>Minimum<br />Payment</th>
      <th>Actual<br />Payment</th>
      <th>Services<br />Asset</th>
    </tr>}
  </thead> || <thead><tr><th></th><th>Debt<br />Principal$</th><th>Monthly<br />Payment+</th><th>Interest%</th></tr></thead>}
  
  {this.state.editDebtRow !== -1 && this.state.debts.map((debt,idx) => idx === this.state.editDebtRow  && <DebtEditRow debt={debt} onConfirm={() => this.setState({editDebtRow:-1})} investments={this.state.investments} index={idx} onChange={(newVal) => this.updDebt(idx,newVal)} onRemove={() => this.remDebt(idx)}/>)}
  {this.state.editDebtRow === -1 && this.state.debts.map((debt,idx) => <DebtListRow onSelect={this.selectDebtRow} debt={debt} investments={this.state.investments} index={idx} onChange={(newVal) => this.updDebt(idx,newVal)} onRemove={() => this.remDebt(idx)}/>)}
   

</table>
{this.state.editDebtRow === -1 && <div className="txtC"><br /><button className="small" onClick={this.addDebt}>Add Debt</button></div>}
</div>}

</div>

{this.state.editDebtRow === -1 && this.state.editInvestRow === -1 && <div className="reportTotals" >

<div>
<div className="tip">Now we can prioritize which debts to pay first in order to maximize your resources. Once you meet all your minimum monthly obligations, this calculator recommends that you maximize your spending on the first item on this list. Read the difference between <a target="_blank" href="https://www.playingwithfire.co/blog/debt-snowball-vs-debt-avalanche-the-showdown">Debt Snowball versus Debt Avalanche</a></div>

<h2 className="inline huge" style={{marginTop:70}}>Priority Allocation</h2>
<div className="txtC">
  <button className={['small', this.state.debtMode === 'avalanche' && 'on' || 'off'].join(' ')} onClick={ () => this.setState({debtMode : 'avalanche'})}>Avalanche</button>
  <button className={['small', this.state.debtMode === 'snowball' && 'on' || 'off'].join(' ')} onClick={() => this.setState({debtMode : 'snowball'})}>Snowball</button>
</div>
<br /><br /><br /> 

{1===2 && <div>
  <h2 className="inline" style={{marginTop:70}}>Priority Investment</h2>
  {1===2 && <button className="small">as input</button>}

  <button className="small">balanced</button> 
  {1===2 && <button className="small">high return</button>} 
  {1===2 && <button className="small">high match</button>}
</div>} 


<table className="priority zebra">
  <thead>
    <tr><th></th><th>Priority Category</th><th className="txtR">Principal</th><th className="txtR">Interest</th><th className="txtR">Return</th>{1===2 && <th className="txtR" width={80}>Time Remain</th>}
    {1===2 && <React.Fragment><th className="txtC">Time</th><th className="txtR">Total</th></React.Fragment>}
    </tr>
  </thead>
  <tbody>
  {this.priority().map(item => <React.Fragment>{item}</React.Fragment>)}
  
</tbody></table> 
</div>


<div>
  <div className="tip">This graph shows your projected net worth in 30 years if you pay debts first or if you prioritize further investment in assets. As you switch between snowball and avalanche approaches to debt repayment, the graph indicates the projected date you will be debt-free.</div>
  {1===2 && <div>
    <h2  className="txtC huge">Monthly Surplus</h2>
    <div className="txtC huge">{this.money(this.surplus())}</div>
  </div>}
<h2 className="txtC huge" style={{marginTop:70}}>Invest or Pay Debt<br />Net Worth Growth</h2>
<DebtInvestCharts approach={this.state.debtMode} resultA={this.simulate(12*30,this.state.debtMode)} resultB={this.simulate(12*30,'neutral')}/>
{1===2 && <DebtInvestGraph start={this.portfolio(0)} enda={this.simResult(12*30,this.state.debtMode).assets} endb={this.simResult(12*30,'neutral').assets}  markera={this.simResult(12*100, this.state.debtMode ).debtfreeMonths / 360} markerb={this.simResult(12*100,'neutral').debtfreeMonths / 360} markeraText={ this.state.debtMode + " debt " + this.outDebtCaption( this.simResult(12*100,this.state.debtMode).debtfreeMonths ) } markerbText={ "your current approach " + this.outDebtCaption( this.simResult(12*100,'neutral').debtfreeMonths )} />}
</div>


 
{1===2 && <div>

MONTHLY SURPLUS FUNDS
<h2>{this.money(this.surplus())}</h2>
<br />
MONTHLY MINIMUM PAYMENTS 
<h2>{this.money(this.monthlyMin())}</h2>
</div>}

{1===2 && <div>year total / payments / total debt remain</div>}
{1===2 && <div className="linear">
{1===2 && [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(v => <div >end year {v}: { this.money(this.monthlyMin()  *  12 * 1 * v)} 

 &nbsp;{this.money(this.state.debts.reduce((acc,d) => acc + (d.principal || 0),0) - this.monthlyMin() *  12 * 1 * v )}

</div>)}</div>}

{1===2 && [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(v => <div>end year {v}: { this.money(  (this.monthlyMin() + this.surplus())  *  12 * 1 * v)} 

 &nbsp;{this.money(this.state.debts.reduce((acc,d) => acc + (d.principal || 0),0) - ( (this.monthlyMin() + this.surplus()) *  12 * 1 * v )  )}

</div>)}




{1===2 && <div>
<div className="fifty50" style={{marginTop:70}}>
<h2>Debt Financing Cost</h2>
<div className="huge">$5,000</div>
<div className="guide">
Cost of debt is the accumulated interest cost starting today until the debt is paid and no longer accumulates interest, the longer you take to pay down the more it costs.
</div>
</div>
<div className="fifty50" style={{marginTop:70}}>
<h2>Opportunities Cost</h2>
<div className="huge">$5,000</div>
<div className="guide">
Opportunites are unrealized return with money you are spending to service debt instead of investment money in assets with a positive yield.<br /><br />
</div>
</div>
</div>}

{1===2 && <div>
<h3 style={{marginTop:70}}>Savings Based on Recommendation</h3>
<div className="guide">

  Pay off high interest debt firstly and debt which services a fast-depreciating asset. Then grow your wealth by contributing to an asset which demonstrates consistent yields.
</div>

<br /><br />
<table className="calcTotals">
<thead>

</thead>
<tbody>
 
  
  <tr>
    
    <td className="txtR"><div className="tinyLabel">TODAY</div><div className="verybig">$5k</div></td>
    <td className="txtR"><div className="tinyLabel">5 YR</div><div className="verybig">$25k</div></td>
    <td className="txtR"><div className="tinyLabel">30 YR</div><div className="verybig">$130k</div></td>


  </tr>
 
</tbody>
</table>

</div>}


{1===2 && <div>

<h3>Totals and Projections</h3>
<div className="guide">
  Here are totals for your current assets and debts follow by a projected accumulation if your current situation remains entriely unchanged.

<br /><br />
</div>

<table className="calcTotals">
<thead>

</thead>
<tbody>
  <tr><td colSpan={3} className="big">investments</td></tr>
  <tr>
    
    <td className="txtR"><div className="tinyLabel">TODAY</div><div className="verybig">{this.k(this.investTotal(0))}</div></td>
    <td className="txtR"><div className="tinyLabel">5 YR</div><div className="verybig">{this.k(this.investTotal(60))}</div></td>
    <td className="txtR"><div className="tinyLabel">30 YR</div><div className="verybig">{this.k(this.investTotal(240))}</div></td>


  </tr>
  <tr><td colSpan={3} className="big">debts</td></tr>
  <tr>
    
    <td className="txtR"><div className="tinyLabel">TODAY</div><div className="verybig">{this.k(this.debtTotal(0))}</div></td>
    <td className="txtR"><div className="tinyLabel">5 YR</div><div className="verybig">{this.k(this.debtTotal(60))}</div></td>
    <td className="txtR"><div className="tinyLabel">30 YR</div><div className="verybig">{this.k(this.debtTotal(240))}</div></td>


  </tr>
  <tr><td colSpan={3} className="big"><div className="totalLine">net worth</div></td></tr>
  <tr>
    
    <td className="txtR"><div className="tinyLabel">TODAY</div><div className="verybig">{this.k(this.portfolio(0))}</div></td>
    <td className="txtR"><div className="tinyLabel">5 YR</div><div className="verybig">{this.k(this.portfolio(60))}</div></td>
    <td className="txtR"><div className="tinyLabel">30 YR</div><div className="verybig">{this.k(this.portfolio(240))}</div></td>


  </tr>
</tbody>
</table>
 
</div>}

  <br />


 
</div>}

{1===2 && <table className="example">
  <caption>EXAMPLE AVERAGE annual return YRS </caption>
  <thead>
    <tr>
    <th>Type</th><th>Investment</th><th>1</th><th>5</th><th>10 Years</th>
    </tr>
  </thead>
  <tbody>
    {this.sampleInvestments().map(item => <tr>{item.split(/\s+/g).map(cell => <td>{cell}</td>)}</tr>)}
  </tbody>
</table>}





    
    </div>);
  }

}

/////// rental //////////////////////
function rental() {
  return {
    initialCost()  {

    },
    recurringCost() {

    },
    opportunityCosts(){

    },
    netProceeds() {

    },
    totalCost() {

    }
  };
}
/////// buyHome //////////////////////
function buyHome() {

  return {
    // home price
    homePrice:0,
    yearStay:0,
    // mortgage
    mortgageRate:0,
    downPayment:0,
    yearsMortgage:0,
    // future
    priceGrowth:0,
    rentGrowth:0,
    investmentReturn:0,
    inflationRate:0,
    // taxes
    individualFile: true, //(joint if false)
    propertyTax:0,
    marginalTax:0,
    // closing costs
    costBuy:0,
    costSell:0,
    // maintenance and fees
    maintenance:0,
    homeOwnersInsurance:0,
    monthlyUtilities:0,
    commonFees:0,
    commonFeesDeduction:0,
    
    initialCost()  {
      return this.homePrice + (this.costBuy * this.homePrice) ;
    },
    futureModifiers() {
      return [this.priceGrowth,this.rentGrowth,this.investmentReturn,this.inflationRate];
    },
    mortgageTotal() {
      return this.homePrice - (this.homePrice * this.downPayment);
    },
    recurringCost() {
      let total = (this.propertyTax * this.homePrice) + (this.maintenance * this.homePrice) + (this.homeOwnersInsurance * this.homePrice) + this.monthlyUtilities + this.commonFees;
      return total * this.yearStay;
    },
    opportunityCosts(){
      //this.investmentReturn

    },
    netProceeds() {
      // this formula is wrong the variables are gathered
      // var out =(this.yearStay * ) -this.homePrice ()
    },
    totalCost() {
      
    }
  };
}
/////// PWFSlider //////////////////////
class PWFSlider extends React.Component {

  values() {
    return this.props?.length || 40;
  }

  spanLength() {

  }

  selectedCol() {
    return 2;
  }

  increment(idx) {
    var out = this.props.min + (  (this.props.max - this.props.min) / (this.values()-1) * idx );
     
    return out.toFixed(1).toString().replace(/\.0$/,'');
  }

  render() {
    return (<div className="pwfSlider">

      <ul className="graph">
      {new Array(this.values()).fill('x').map((item,idx) => <li className={(this.selectedCol() === idx && 'on') || ''} onClick={() => this.props.onChange?.(this.increment(idx))}></li>)}
      </ul>
      <ul className="click">
      {new Array(this.values()).fill('y').map((item,idx) => <li className={(this.selectedCol() === idx && 'on') || ''} onClick={() => this.props.onChange?.(this.increment(idx))}></li>)}
      </ul>
      <ul className="label">
      {new Array(this.values()).fill('z').map((item,idx) => <li className={(this.selectedCol() === idx && 'on') || ''} onClick={() => console.log(item)}>{this.increment(idx)}</li>)}
      </ul>
    </div>);
  }

}
/////// PWFLabelInput //////////////////////
class PWFLabelInput extends React.Component {
  
  render() {
    return(<div className="pwfLabelInput">
      <input type="text" value={parseFloat(this.props.value).toLocaleString()} onChange={(ev) => this.props.onChange?.(ev.target.value)}/>{this.props.unit}
      <PWFSlider value={this.props.value} onChange={(val) => this.props.onChange?.(val)} min={this.props.min} max={this.props.max}/>
      <br />
      <div>{this.props.label}  </div>
      <div className="labelResult">{this.props.result}  </div>
    </div>);
  }

}  
/////// RentBuy //////////////////////
class RentBuy extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // home price
      homePrice:100000,
      yearStay:30,
      // mortgage
      mortgageRate:0,
      downPayment:0,
      yearsMortgage:0,
      // future
      priceGrowth:0,
      rentGrowth:0,
      investmentReturn:0,
      inflationRate:0,
      // taxes
      individualFile: true, //(joint if false)
      propertyTax:0,
      marginalTax:0,
      // closing costs
      costBuy:0,
      costSell:0,
      // maintenance and fees
      maintenance:0,
      homeOwnersInsurance:0,
      monthlyUtilities:0,
      commonFees:0,
      commonFeesDeduction:0,
      // additional renting cost
      securityDeposit:0,
      brokerFee:0,
      rentersInsurance:0
    };
  }

  setVal = (val,lbl) => {
    var out = {};
    out[lbl] = val;
    this.setState(out);
  }

  render() {
    return(<div>
      <h1>Rent Versus Buy Calculator</h1>

      <h3>Home Price</h3>
      
      <PWFLabelInput value={this.state.homePrice} min={30000} max={3000000} onChange={(newVal) => this.setVal(newVal,'homePrice')}/>

      <h3>How Long Do You Plan to Stay?</h3>
      <PWFLabelInput unit="years" value={this.state.yearStay} min={1} max={40} onChange={(newVal) => this.setVal(newVal,'yearStay')}/>

      <section>
        <h3>What Are Your Mortgage Details?</h3>
        <ul>
          <li><PWFLabelInput  label="Mortgage Rate" result={-1 + ' per month'} min={0} max={15} unit="%" value={this.state.mortgageRate} onChange={(newVal) => this.setVal(newVal,'mortgageRate')}/></li>
          <li><PWFLabelInput label="Down Payment" result={'$' + (this.state.downPayment/100 * this.state.homePrice).toFixed(2).toLocaleString()} unit="%" min={0} max={100} value={this.state.downPayment} onChange={(newVal) => this.setVal(newVal,'downPayment')}/></li>
          <li><PWFLabelInput label="Length of Mortgage" unit="years" min={1} max={40} value={this.state.yearsMortgage} onChange={(newVal) => this.setVal(newVal,'yearsMortgage')}/></li>
        </ul>
      </section>
      <section>
        <h3>What Does the Future Hold</h3>
        <ul>
          <li><PWFLabelInput label="Home Price Growth" unit="%" min={-5} max={15} value={this.state.priceGrowth} onChange={(newVal) => this.setVal(newVal,'priceGrowth')}/></li>
          <li><PWFLabelInput label="Rent Growth" unit="%" min={-5} max={15} value={this.state.rentGrowth} onChange={(newVal) => this.setVal(newVal,'rentGrowth')}/></li>
          <li><PWFLabelInput label="Investment Return" unit="%" min={-10} max={20} value={this.state.investmentReturn} onChange={(newVal) => this.setVal(newVal,'investmentReturn')}/></li>
          <li><PWFLabelInput label="Inflation" unit="%" min={-5} max={10} value={this.state.inflationRate} onChange={(newVal) => this.setVal(newVal,'inflationRate')}/></li>
        </ul>
      </section>
      <section>
        <h3>Taxes</h3>
        <ul>
          <li><PWFLabelInput label="Property Tax" result={'$' + (this.state.homePrice * (this.state.propertyTax/100)).toFixed(0).toLocaleString() + ' for first year'} unit="%" min={0} max={10} value={this.state.propertyTax} onChange={(newVal) => this.setVal(newVal,'propertyTax')}/></li>
          <li><PWFLabelInput label="Marginal Tax" unit="%" min={0} max={50} value={this.state.marginalTax} onChange={(newVal) => this.setVal(newVal,'marginalTax')}/></li>
        </ul>
      </section>
      <section>
        <h3>Closing Costs</h3>
        <ul>
          <li><PWFLabelInput label="Costs of Buying Home" result={'$' + (this.state.homePrice * (this.state.costBuy/100)).toFixed(0).toLocaleString() } unit="%"  min={0} max={10} value={this.state.costBuy} onChange={(newVal) => this.setVal(newVal,'costBuy')}/></li>
          <li><PWFLabelInput label="Costs of Selling Home" result={-1} unit="%"  min={0} max={10} value={this.state.costSell} onChange={(newVal) => this.setVal(newVal,'costSell')}/></li>
        </ul>
      </section>
      <section>
        <h3>Maintenance and Fees</h3>
        <ul>
          <li><PWFLabelInput label="Maintence" unit="%" result={'$' + (this.state.homePrice * (this.state.maintenance/100)).toFixed(0).toLocaleString() + ' for first year'} min={0} max={10} value={this.state.maintenance} onChange={(newVal) => this.setVal(newVal,'maintenance')}/></li>
          <li><PWFLabelInput label="Homeowner's insurance" unit="%"  result={'$' + (this.state.homePrice * (this.state.homeOwnersInsurance/100)).toFixed(0) + ' for first year'} min={0} max={10} value={this.state.homeOwnersInsurance} onChange={(newVal) => this.setVal(newVal,'homeOwnersInsurance')}/></li>
          <li><PWFLabelInput label="Monthly utilities" unit="$"  min={0} max={2000} value={this.state.monthlyUtilities} onChange={(newVal) => this.setVal(newVal,'monthlyUtilities')}/></li>
          <li><PWFLabelInput label="Monthly common fees" unit="$"  min={0} max={4000} value={this.state.commonFees} onChange={(newVal) => this.setVal(newVal,'commonFees')}/></li>
          <li><PWFLabelInput label="Common fees deduction" unit="%"  min={0} max={100} value={this.state.commonFeesDeduction} onChange={(newVal) => this.setVal(newVal,'commonFeesDeduction')}/></li>
          
        </ul>
      </section>

      {1===2 && <section>
        <h3>Additional Renting Costs</h3>
        <ul>
          <li>Security deposit</li>
          <li>Broker's fee</li>
          <li>Renter's insurance</li>
      
        </ul>
      </section>}
      

    </div>);
  }

}   
/////// BudgetCalc //////////////////////
class BudgetCalc extends FinCalc {

  constructor(props) {
    super(props);
    this.state = {netMonthly:3000};
  }

  applyBudget(factor) {
    let out = Math.round((this.state.netMonthly ?? 0) * factor);
    out = '$' + out.toLocaleString();
    return out;
  }

  saveRate() {
    return .5;
  }

  neccessitiesRate() {
    return .3;
  }

  wantsRate() {
    return .2;
  }

  render() {
    return (<div>
      <ul>
       <li>
          <label>Monthly after-tax income</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.netMonthly)} onChange={(ev) => this.setState({netMonthly: this.dollar(ev.target.value)})}/>
        </li>
        <li>
          <h3>Savings and debt repayment</h3>
          <div className="total">{this.applyBudget(this.saveRate())}</div>
        </li>
        <li>
          <h3>Necessities</h3>
          <div className="total">{this.applyBudget(this.neccessitiesRate())}</div>
        </li>
        <li>
          <h3>Wants</h3>
          <div className="total">{this.applyBudget(this.wantsRate())}</div>
        </li>

      </ul>  
    </div>);
  }

} 
/////// DebtIncomeRatio //////////////////////
class DebtIncomeRatio extends FinCalc {

  total() {
    let debt = (this.state.mortgage ?? 0) + (this.state.studentLoan ?? 0) + (this.state.personalLoan ?? 0) + (this.state.carLoan ?? 0) + (this.state.creditCard ?? 0) + (this.state.childSupport ?? 0);
    let out = Math.round(debt / (this.state.grossMonthly ?? 0) * 100);
    if (isNaN(out)) {
      out ='';
    } else {
      out = out.toLocaleString() + '%';
    }
    return out;
  }

  render() {
    return(<div>
      <h3>Expenses</h3>
      <ul>
        <li>
          <label>Mortgage or rent payment</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.mortgage)} onChange={(ev) => this.setState({mortgage: this.dollar(ev.target.value)})}/>
        </li>
        <li>
          <label>Minimum student loan(s) payment</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.studentLoan)} onChange={(ev) => this.setState({studentLoan: this.dollar(ev.target.value)})}/>
        </li>
        <li>
          <label>Personal loan(s) payment</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.personalLoan)} onChange={(ev) => this.setState({personalLoan: this.dollar(ev.target.value)})}/>
        </li>
        <li>
          <label>Car loan or lease payment(s)</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.carLoan)} onChange={(ev) => this.setState({carLoan: this.dollar(ev.target.value)})}/>
        </li>
        <li>
          <label>Minimum credit card(s) payment</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.creditCard)} onChange={(ev) => this.setState({creditCard: this.dollar(ev.target.value)})}/>
        </li>
        <li>
          <label>Child support &amp; other regular payments</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.childSupport)} onChange={(ev) => this.setState({childSupport: this.dollar(ev.target.value)})}/>
        </li>

      </ul>
      <h3>Income</h3>
      <ul>
        <li>
          <label>Gross monthly income</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.grossMonthly)} onChange={(ev) => this.setState({grossMonthly: this.dollar(ev.target.value)})}/>
        </li>
      </ul>
      <h3>Your debt-to-income ratio</h3>
      <div className="total">{this.total()}</div>
    </div>);
  }

}  

/////// SavingsCalculator //////////////////////
class SavingsCalculator extends FinCalc {

  constructor(props) {
    super(props);
    this.state = {yearlyIncome:50000,yearlySavings:5000, interval: 'Yearly'};
  }

  render() {
    return(<div>
      <button className={(this.state.interval === 'Yearly' && 'on') || 'toggle'} onClick={() => this.setState({interval:'Yearly'})}>Yearly</button> <button className={(this.state.interval === 'Monthly' && 'on') || 'toggle'} onClick={() => this.setState({interval:'Monthly'})}>Monthly</button> <button className={(this.state.interval === 'Weekly' && 'on') || 'toggle'} onClick={() => this.setState({interval:'Weekly'})}>Weekly</button>
      <br /><br />
      <ul>
      <li>
        <label>{this.state.interval} after-tax income</label>
        <input type="text" placeholder="$0" size={10} value={this.money(this.state.yearlyIncome)} onChange={(ev) => this.setState({yearlyIncome: this.dollar(ev.target.value)})}/>
      </li> 
      <li>
        <label>{this.state.interval} savings for retirement</label>
        <input type="text" placeholder="$0" size={10} value={this.money(this.state.yearlySavings)} onChange={(ev) => this.setState({yearlySavings: this.dollar(ev.target.value)})}/>
      </li>      
      </ul>
      <h3>Savings Rate</h3>
      <div className="total">{this.total()}</div>
    </div>);
  }

  total() {
    let out = (Math.round(this.state.yearlySavings ?? 0) / (this.state.yearlyIncome ?? 0) * 100);
    if (isNaN(out)) {
      out ='';
    } else {
      out = out.toLocaleString() + '%';
    }
    return out;
  }

}

/////// NETWORTH /////////////////////////////
class NetWorth extends FinCalc {

  constructor(props) {
    super(props);
    this.state = {assets:{},liabilities:{}};
  }

  assets() {
    return (this.state.realEstate ?? 0) + (this.state.checkingAccounts ?? 0) + (this.state.savingsAccounts ?? 0) + (this.state.retirementAccounts ?? 0) + (this.state.autos ?? 0) + (this.state.other ?? 0);
  }

  liabilities() {
    return (this.state.mortgages ?? 0) + (this.state.consumerDebt ?? 0) + (this.state.personalLoans ?? 0) + (this.state.studentLoans ?? 0) + (this.state.autoLoans ?? 0) + (this.state.otherDebt ?? 0);
  }

  total() {
    return this.money(this.assets() - this.liabilities());
  }

  render() {
    return (<div>

      <div className="assets">
      <h3>Your Assets</h3>
      <ul>

        <li>
          <label>Real estate</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.realEstate)} onChange={(ev) => this.setState({realEstate: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Checking accounts</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.checkingAccounts)} onChange={(ev) => this.setState({checkingAccounts: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Savings accounts</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.savingsAccounts)} onChange={(ev) => this.setState({savingsAccounts: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Retirement accounts</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.retirementAccounts)} onChange={(ev) => this.setState({retirementAccounts: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Autos</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.autos)} onChange={(ev) => this.setState({autos: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Other</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.other)} onChange={(ev) => this.setState({other: this.dollar(ev.target.value)})}/>
        </li>

      </ul>
      </div>

      <div className="liabilities">
      <h3>Your Liabilities</h3>
      <ul>

        <li>
          <label>Mortgages</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.mortgages)} onChange={(ev) => this.setState({mortgages: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Consumer debt</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.consumerDebt)} onChange={(ev) => this.setState({consumerDebt: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Personal loans</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.personalLoans)} onChange={(ev) => this.setState({personalLoans: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Student loans</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.studentLoans)} onChange={(ev) => this.setState({studentLoans: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Auto loans</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.autoLoans)} onChange={(ev) => this.setState({autoLoans: this.dollar(ev.target.value)})}/>
        </li>

        <li>
          <label>Other debt</label>
          <input type="text" placeholder="$0" size={10} value={this.money(this.state.otherDebt)} onChange={(ev) => this.setState({otherDebt: this.dollar(ev.target.value)})}/>
        </li>

      </ul>
      </div>
      <h3>Your Net Worth</h3>
      <div className="total result">{this.total()}</div>
    </div>);
  }

}
export default App;
